import { Dialog, DrawerContent } from "@buddy/ui";
import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { Sidebar } from "@/app/sidebar";
import { useUi } from "@/app/ui-state";
import { SIDEBAR_DOCKS_AT } from "@/features/computer/layout";

// Home, chats, tasks, team and the notebook share the chat sidebar. Settings has its own.
// From 960 wide it docks beside the page; narrower, the rail's sidebar button opens it as
// a drawer over the page, which closes on Escape, a click outside, or opening anything.
export const Route = createFileRoute("/_app/_main")({ component: Main });

function Main() {
  const { sidebarOpen, setSidebarOpen } = useUi();
  const href = useRouterState({ select: (state) => state.location.href });

  // Picking a row (a navigation) is done with the drawer.
  useEffect(() => setSidebarOpen(false), [href, setSidebarOpen]);

  // A window that grows wide enough docks the sidebar, so a drawer left open would be a second copy.
  useEffect(() => {
    const docked = window.matchMedia(`(min-width: ${SIDEBAR_DOCKS_AT}px)`);
    const onChange = () => docked.matches && setSidebarOpen(false);
    docked.addEventListener("change", onChange);
    return () => docked.removeEventListener("change", onChange);
  }, [setSidebarOpen]);

  return (
    <>
      <div className="hidden shrink-0 min-[960px]:flex">
        <Sidebar />
      </div>
      <Dialog open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <DrawerContent aria-label="Sidebar">
          <Sidebar />
        </DrawerContent>
      </Dialog>
      <Outlet />
    </>
  );
}
